/* eslint-disable sort-imports */
/* eslint-disable camelcase */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable no-param-reassign */

import Swiper from 'swiper';

class PartnersLobbyInstance {
  constructor(node) {
    this.block = node;

    this.selectors = {
      types: '.b-partners-lobby__types',
      type: '.b-partners-lobby__type',
      posts: '.b-partners-lobby__posts',
      post: '.b-partners-lobby__post',
      postCard: '.b-partners-lobby__post-card',
      postTag: '.b-partners-lobby__post-tag',
      body: '.b-partners-lobby__body',
      title: '.b-partners-lobby__title-inner',
      industrySelect: '.b-partners-lobby__filter-industry-select',
      dialog: '.b-partners-lobby__dialog',
      dialogMask: '.b-partners-lobby__dialog-mask',
      dialogClose: '.b-partners-lobby__dialog-close',
      clearFilter: '.b-partners-lobby__filter-clear',
      allRegions: '.b-partners-lobby__title-all-regions-btn',
    };

    this.classes = {
      typeActive: 'b-partners-lobby__type--selected',
      typeWrap: 'b-partners-lobby__types-wrap',
      type: 'b-partners-lobby__type',
      postHidden: 'b-partners-lobby__post--hidden',
      postWithDialog: 'b-partners-lobby__post--with-dialog',
      postWithUrl: 'b-partners-lobby__post--with-url',
      placeholder: 'b-partners-lobby__placeholder',
      dialogHidden: 'b-partners-lobby__dialog--hidden',
    };

    if (!this.block) {
      return;
    }

    this.bootstrap();
  }

  bootstrap() {
    this.initTypes();
    this.initSlider();
    this.initBody();

    this.anchorInit();
  }

  anchorInit() {
    const hash = location.hash.replace('#', '');
    const types = [ ...this.block.querySelectorAll(this.selectors.type) ];

    types.forEach(type => {
      const { slug } = type.dataset;

      if (slug === hash) {
        type.click();
      }
    });
  }

  selectType(selected, $type = 'industry', region = false) {
    const posts = [ ...this.block.querySelectorAll(this.selectors.post) ];
    const clearFilter = this.block.querySelector(this.selectors.clearFilter);
    const allRegions = this.block.querySelector(this.selectors.allRegions);
    let hasResults = false;

    posts.forEach(post => {
      let hasTag = false;

      if ($type === 'application') {
        hasTag = post.querySelector(`[data-application="${selected}"]`);
      } else {
        hasTag = post.querySelector(`[data-industry="${selected}"]`);
      }

      if (hasTag) {
        hasResults = true;
      }

      if (!selected || hasTag) {
        post.classList.remove(this.classes.postHidden);
      } else {
        post.classList.add(this.classes.postHidden);
      }
    });

    if (hasResults) {
      if (clearFilter) {
        clearFilter.classList.remove('b-partners-lobby__filter-clear--hidden');
      }

      if (allRegions && region) {
        allRegions.classList.remove('b-partners-lobby__title-all-regions-btn--hidden');
      }
    } else {
      if (clearFilter) {
        clearFilter.classList.add('b-partners-lobby__filter-clear--hidden');
      }

      if (allRegions && region) {
        allRegions.classList.add('b-partners-lobby__title-all-regions-btn--hidden');
      }
    }

    if ($type === 'industry') {
      const industrySelect = this.block.querySelector(
        this.selectors.industrySelect,
      );

      if (industrySelect) {
        industrySelect.value = selected;
      }
    }
  }

  initBody() {
    const industrySelect = this.block.querySelector(
      this.selectors.industrySelect,
    );

    if (industrySelect) {
      industrySelect.addEventListener('change', event => {
        const selected = event.target.value;

        this.selectType(selected);
      });
    }

    const clearFilter = this.block.querySelector(
      this.selectors.clearFilter
    );

    if (clearFilter) {
      clearFilter.addEventListener('click', () => {
        this.selectType('');
      });
    }

    const dialogs = [ ...this.block.querySelectorAll(this.selectors.dialog) ];

    dialogs.forEach(dialog => {
      const close = dialog.querySelector(this.selectors.dialogClose);
      const mask = dialog.querySelector(this.selectors.dialogMask);

      if (close) {
        close.addEventListener('click', () => {
          dialog.classList.add(this.classes.dialogHidden);
        });
      }

      if (mask) {
        mask.addEventListener('click', () => {
          dialog.classList.add(this.classes.dialogHidden);
        });
      }
    });

    const posts = [ ...this.block.querySelectorAll(this.selectors.post) ];

    posts.forEach(post => {
      const { forDialog, href } = post.dataset;

      if (forDialog > 0) {
        const dialog = this.block.querySelector(
          `[data-dialog="partner-${forDialog}"]`,
        );

        if (dialog) {
          post.classList.add(this.classes.postWithDialog);

          const card = post.querySelector(this.selectors.postCard);

          card.addEventListener('click', () => {
            dialog.classList.remove(this.classes.dialogHidden);
          });
        }
      }

      if (href && href.length > 0) {
        const hasUrl = this.block.querySelector(
          `[data-href="${href}"]`,
        );

        if (hasUrl) {
          post.classList.add(this.classes.postWithUrl);

          const card = post.querySelector(this.selectors.postCard);

          card.addEventListener('click', () => {
            window.open(href, '_blank');
          });
        }
      }
    });

    const postTags = [ ...this.block.querySelectorAll(this.selectors.postTag) ];

    postTags.forEach(tag => {
      tag.addEventListener('click', () => {
        const { application, region } = tag.dataset;

        this.selectType(application, 'application', region);
      });
    });

    const allRegions = this.block.querySelector(this.selectors.allRegions);

    if (allRegions) {
      allRegions.addEventListener('click', () => {
        this.selectType('');
      });
    }
  }

  initTypes() {
    const types = [ ...this.block.querySelectorAll(this.selectors.type) ];

    types.forEach(type => {
      type.addEventListener('click', () => {
        types.forEach(typeToRemove => {
          typeToRemove.classList.remove(this.classes.typeActive);
        });

        type.classList.add(this.classes.typeActive);

        const { slug } = type.dataset;

        this.loadType(slug);
      });
    });
  }

  initSlider() {
    const sliders = [ ...this.block.querySelectorAll(this.selectors.types) ];

    if (sliders.length === 0) {
      return;
    }

    sliders.forEach(slider => {
      // eslint-disable-next-line no-new
      new Swiper(slider, {
        slidesPerView: 'auto',
        loop: false,
        wrapperClass: this.classes.typeWrap,
        slideClass: this.classes.type,
      });
    });
  }

  loadType(type) {
    const title = this.block.querySelector(this.selectors.title);
    const body = this.block.querySelector(this.selectors.body);
    const posts = [ ...this.block.querySelectorAll(this.selectors.post) ];

    title.classList.add(this.classes.placeholder);

    posts.forEach(post => {
      post.classList.add(this.classes.placeholder);
    });

    const { nonce, allIndustriesText, filterByText } = body.dataset;

    const data = new FormData();

    data.append('action', 'af_fetch_partners_lobby');
    data.append('type', type);
    data.append('allIndustriesText', allIndustriesText);
    data.append('filterByText', filterByText);
    data.append('nonce', nonce);

    fetch(window.af_app.ajaxurl, {
      method: 'POST',
      body: data,
    })
      .then(result => result.text())
      .then(responseData => {
        body.innerHTML = responseData;

        this.initBody();
      });
  }
}
export default class PartnersLobby {
  constructor() {
    this.selector = '.b-partners-lobby';
  }

  bootstrap() {
    const nodes = document.querySelectorAll(this.selector);

    nodes.forEach(node => new PartnersLobbyInstance(node));
  }
}
